<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

<form
  class="modal-content"
  #f="ngForm"
  (ngSubmit)="updateActiveDoc()"
  autocomplete="off">
  <div class="modal-header">
    <h5 class="modal-title">{{ doc.fileName }}</h5>
  </div>
  <div class="modal-body" tabindex="-1">
    <div class="doc-info-top">
      <h5 class="mt-0">
        <span [xdaTranslate]="'SDE_SECURITY'"></span>
        <span>: </span>
        <span [xdaTranslate]="doc.documentSecurityLevel || ''"></span>
      </h5>
      <div class="form-group row">
        <div class="col-12">
          <label class="d-flex">
            <span [xdaTranslate]="'SDE_EXPIRATION_DATE'"></span>
            @if (doc.documentExpiresSoon) {
              <span
                class="expire-soon xgl-alert_alt xglsize-24"
                placement="bottom"
                [ngbTooltip]="doc.documentExpiryToolTip"></span>
            }
          </label>
        </div>
        <div class="expire-wrapper d-flex col-12">
          <xrx-calendar
            name="expiryDate"
            [(ngModel)]="doc.documentExpiryDateNgbDateStruct"
            [maxDate]="doc.documentMaxDateNgbDateStruct || null"
            [minDate]="doc.documentMinDateNgbDateStruct || null"
            (change)="onExpirationChange($event)"></xrx-calendar>
          <div class="button-wrapper">
            <button
              type="button"
              class="xrx-btn btn-secondary xgl-calendar_cancel"
              [disabled]="doc.documentStatus == 'SDE_EXPIRED'"
              (click)="expireNow()">
              <span class="pl-2" [xdaTranslate]="'SDE_EXPIRE_NOW'"></span>
            </button>
          </div>
        </div>
      </div>
    </div>
    @if (doc.documentSecurityLevel == 'SDE_TRACK_VIEWS') {
      <div class="doc-info-middle row">
        <div class="col-12 col-md-6">
          <p>
            <span [xdaTranslate]="'SDE_PAGES'"></span>
            <span>: </span>
            <span>{{ doc.pages }}</span>
          </p>
          <p>
            <span [xdaTranslate]="'SDE_INCLUDE_TIMESTAMP'"></span>
            <span>: </span>
            <span
              [xdaTranslate]="
                doc.documentOptions.timestamp == true ? 'SDE_YES' : 'SDE_NO'
              "></span>
          </p>
          <p>
            <span [xdaTranslate]="'SDE_RESPOND_TO'"></span>
            <span>: </span>
            <span [xdaTranslate]="doc.respondTo || ''"></span>
          </p>
        </div>
        <div class="col-12 col-md-6">
          <p>
            <span [xdaTranslate]="'SDE_ALLOW_PRINTING'"></span>
            <span>: </span>
            <span
              [xdaTranslate]="
                doc.documentOptions.print == true ? 'SDE_YES' : 'SDE_NO'
              "></span>
          </p>
          <p>
            <span [xdaTranslate]="'SDE_DISCLOSE_USER_LIST1'"></span>
            <span>: </span>
            <span
              [xdaTranslate]="
                doc.documentOptions.distributionList == true
                  ? 'SDE_YES'
                  : 'SDE_NO'
              "></span>
          </p>
        </div>
      </div>
    }
    @if (doc.documentSecurityLevel != 'SDE_TRACK_VIEWS') {
      <div class="doc-info-middle row">
        <div class="col-12 col-md-6">
          <p>
            <span [xdaTranslate]="'SDE_PAGES'"></span>
            <span>: </span>
            <span>{{ doc.pages }}</span>
          </p>
          <p>
            <span [xdaTranslate]="'SDE_MAXIMUM_VIEWS_PER'"></span>
            <span>: </span>
            <span
              [xdaTranslate]="
                doc.documentOptions.maxReads > 0
                  ? doc.documentOptions.maxReads.toString()
                  : 'SDE_UNLIMITED'
              "></span>
          </p>
          <p>
            <span [xdaTranslate]="'SDE_IDENTIFY_SCREEN_CAPTURE'"></span>
            <span>: </span>
            <span
              [xdaTranslate]="
                doc.documentOptions.steganography == true ? 'SDE_YES' : 'SDE_NO'
              "></span>
          </p>
          <p>
            <span [xdaTranslate]="'SDE_RESPOND_TO'"></span>
            <span>: </span>
            <span [xdaTranslate]="doc.respondTo || ''"></span>
          </p>
        </div>
        <div class="col-12 col-md-6">
          <p>
            <span [xdaTranslate]="'SDE_INCLUDE_TIMESTAMP'"></span>
            <span>: </span>
            <span
              [xdaTranslate]="
                doc.documentOptions.timestamp == true ? 'SDE_YES' : 'SDE_NO'
              "></span>
          </p>
          <p>
            <span [xdaTranslate]="'SDE_ALLOW_PRINTING'"></span>
            <span>: </span>
            <span
              [xdaTranslate]="
                doc.documentOptions.print == true ? 'SDE_YES' : 'SDE_NO'
              "></span>
          </p>
          <p>
            <span [xdaTranslate]="'SDE_DISCLOSE_USER_LIST1'"></span>
            <span>: </span>
            <span
              [xdaTranslate]="
                doc.documentOptions.distributionList == true
                  ? 'SDE_YES'
                  : 'SDE_NO'
              "></span>
          </p>
          @if (doc.documentSecurityLevel != 'SDE_RESTRICT_TRACK_VIEWERS') {
            <p>
              <span [xdaTranslate]="'SDE_LIMIT_DOMAINS'"></span>
              <span>: </span>
              <span
                [xdaTranslate]="
                  doc.documentDomainList && doc.documentDomainList.length > 0
                    ? 'SDE_YES'
                    : 'SDE_NO'
                "></span>
              @if (
                doc.documentDomainList && doc.documentDomainList.length > 0
              ) {
                <button
                  class="xrx-btn btn-xs btn-secondary view-domains"
                  (click)="viewDomains($event)"
                  [xdaTranslate]="'SDE_VIEW'"></button>
              }
            </p>
          }
        </div>
      </div>
    }
    <hr />
    <div class="doc-info-bottom">
      <p>
        <span [xdaTranslate]="'SDE_NUMBER_OF_VIEWS'"></span>
        <span>: </span>
        <span>{{ doc.documentNumberOfViews }}</span>
      </p>
      <p>
        <span [xdaTranslate]="'SDE_TOTAL_VIEWING_TIME'"></span>
        <span>: </span>
        <span>{{ totalViewTime }}</span>
      </p>
    </div>
    @if (
      doc.documentSecurityLevel != 'SDE_TRACK_VIEWS' &&
      authorizedUserList.length
    ) {
      <div class="doc-info-table">
        <div class="table-responsive">
          <table class="table table-sort mb-0">
            <thead>
              <tr>
                <th
                  sortableCol="user"
                  direction="asc"
                  (sort)="setSortParams($event)"
                  [initialSort]="true"
                  class="sort-active user-email">
                  <span xdaTranslate>SDE_AUTHORIZED_USERS</span>
                </th>
                <th
                  sortableCol="firstView"
                  direction="asc"
                  (sort)="setSortParams($event)"
                  sorttype="number"
                  class="sort-active first-view">
                  <span xdaTranslate>SDE_FIRST_VIEW</span>
                </th>
                <th
                  sortableCol="view"
                  direction="asc"
                  (sort)="setSortParams($event)"
                  sorttype="number"
                  class="sort-active user-views">
                  <span xdaTranslate>SDE_VIEWS</span>
                </th>
                <th
                  sortableCol="viewTimeSeconds"
                  direction="asc"
                  (sort)="setSortParams($event)"
                  sorttype="number"
                  class="sort-active user-view-times">
                  <span xdaTranslate>SDE_VIEW_TIME</span>
                </th>
                <th [xdaTranslate]="'SDE_ACTIVE'"></th>
              </tr>
            </thead>
            <tbody>
              @for (
                user of authorizedUserList
                  | tableSort: direction : column : type
                  | slice: (page - 1) * pageSize : page * pageSize;
                track user;
                let i = $index
              ) {
                <tr>
                  <td>{{ $any(user).user }}</td>
                  <td>
                    <span class="first-view-wrapper">
                      <span class="view-date">{{
                        $any(user).firstViewDate
                      }}</span>
                      <span class="view-time">{{
                        $any(user).firstViewTime
                      }}</span>
                    </span>
                  </td>
                  <td>{{ $any(user).views }}</td>
                  <td>{{ $any(user).viewTime }}</td>
                  <td>
                    <xrx-toggle-switch
                      (toggle)="onToggle($any(user))"
                      [isMfd]="false"
                      [switchOn]="$any(user).enabled">
                    </xrx-toggle-switch>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
        @if (
          authorizedUserList && authorizedUserList.length && displayPagination
        ) {
          <xrx-pagination
            [(page)]="page"
            [(pageSize)]="pageSize"
            [initialPageSize]="initialPageSize"
            [pageSizeList]="pageSizeList"
            [collectionSize]="authorizedUserList.length"
            class="d-flex justify-content-center justify-content-sm-end">
          </xrx-pagination>
        }
      </div>
    }
  </div>
  <div class="modal-footer">
    <div class="cb">
      <button
        type="button"
        class="xrx-btn btn-secondary"
        data-dismiss="modal"
        (click)="activeModal.dismiss()">
        <span class="btn-label" [xdaTranslate]="'SDE_CANCEL'"></span>
      </button>
    </div>
    <div class="cb">
      <button type="submit" class="xrx-btn btn-primary">
        <span class="btn-label" [xdaTranslate]="'SDE_OK'"></span>
      </button>
    </div>
  </div>
</form>
